import { Link } from 'react-router-dom';
import { Menu, X, Send } from 'lucide-react';
import { useState } from 'react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
            <nav className="container mx-auto px-4 py-4">
                <div className="flex items-center justify-between">
                    <Link to="/" className="flex items-center space-x-2">
                        <div>
                            <img src='./logo.png' className='w-12 h-12' />
                        </div>
                        <div>
                            <p className='text-3xl font-bold text-emerald-800 leading-none'>MOJO</p>
                            <p className='text-lg font-bold text-emerald-800 leading-none'>MONEY</p>

                        </div>
                        {/* <span className="text-2xl font-bold text-emerald-800">MOJO MONEY</span> */}
                    </Link>

                    <button
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="lg:hidden text-emerald-800"
                    >
                        {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>

                    <div className="hidden lg:flex items-center space-x-8">
                        <Link to="/" className="text-gray-700 hover:text-emerald-800 transition">Home</Link>
                        <Link to="/features" className="text-gray-700 hover:text-emerald-800 transition">Features</Link>
                        <Link to="/exchange-rates" className="text-gray-700 hover:text-emerald-800 transition">Exchange Rates</Link>
                        <Link to="/banks" className="text-gray-700 hover:text-emerald-800 transition">Partner Banks</Link>
                        <Link to="/merchants" className="text-gray-700 hover:text-emerald-800 transition">Merchants</Link>
                        <Link to="/campaigns" className="text-gray-700 hover:text-emerald-800 transition">Campaigns</Link>
                        <Link to="/about" className="text-gray-700 hover:text-emerald-800 transition">About</Link>
                        <Link to="/contact" className="text-gray-700 hover:text-emerald-800 transition">Contact</Link>
                        <Link to="/faq" className="text-gray-700 hover:text-emerald-800 transition">FAQ</Link>
                    </div>
                </div>

                {isMenuOpen && (
                    <div className="lg:hidden mt-4 pb-4 space-y-4">
                        <Link to="/" className="block text-gray-700 hover:text-emerald-800 transition" onClick={() => setIsMenuOpen(false)}>Home</Link>
                        <Link to="/features" className="block text-gray-700 hover:text-emerald-800 transition" onClick={() => setIsMenuOpen(false)}>Features</Link>
                        <Link to="/exchange-rates" className="block text-gray-700 hover:text-emerald-800 transition" onClick={() => setIsMenuOpen(false)}>Exchange Rates</Link>
                        <Link to="/banks" className="block text-gray-700 hover:text-emerald-800 transition" onClick={() => setIsMenuOpen(false)}>Partner Banks</Link>
                        <Link to="/merchants" className="block text-gray-700 hover:text-emerald-800 transition" onClick={() => setIsMenuOpen(false)}>Merchants</Link>
                        <Link to="/campaigns" className="block text-gray-700 hover:text-emerald-800 transition" onClick={() => setIsMenuOpen(false)}>Campaigns</Link>
                        <Link to="/about" className="block text-gray-700 hover:text-emerald-800 transition" onClick={() => setIsMenuOpen(false)}>About</Link>
                        <Link to="/contact" className="block text-gray-700 hover:text-emerald-800 transition" onClick={() => setIsMenuOpen(false)}>Contact</Link>
                        <Link to="/faq" className="block text-gray-700 hover:text-emerald-800 transition" onClick={() => setIsMenuOpen(false)}>FAQ</Link>
                    </div>
                )}
            </nav>
        </header>
    )
}

export default Header
